import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './plugins/base'
import './plugins/chartist'
import Echo from 'laravel-echo'
import { SOCKET_URL } from '@/environment/index'
// import './plugins/vue-world-map'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

// import './plugins/vee-validate'
import VueFormulate from '@braid/vue-formulate'
import '../node_modules/@braid/vue-formulate/themes/snow/snow.scss'
Vue.use(VueFormulate)

window.io = require('socket.io-client')
Vue.config.productionTip = false
window.Echo = new Echo({
  broadcaster: 'socket.io',
  host: SOCKET_URL,
  auth: {
    headers: {
      /** I'm using access tokens to access  **/
      Authorization: 'Bearer ' + store.state.user.token,
    },
  },
})

Vue.http.interceptors.push((request, next) => {
  request.headers.set('Authorization', 'Bearer ' + store.state.user.token)
  next();
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
